(function(){
  if(window.__ruffoPdpCroLoaded)return;
  window.__ruffoPdpCroLoaded=true;

  const clean=v=>String(v||'').replace(/\s+/g,' ').trim();
  const strip=html=>{
    const box=document.createElement('div');
    box.innerHTML=String(html||'');
    return clean(box.textContent||box.innerText||'');
  };
  const directChild=(node,parent)=>{
    let current=node;
    while(current&&current.parentElement&&current.parentElement!==parent&&parent.contains(current.parentElement)) current=current.parentElement;
    return current;
  };

  function productData(section){
    const id=section.dataset.sectionId;
    if(!id)return null;
    try{
      const el=document.getElementById('ProductJson-'+id);
      return el?JSON.parse(el.textContent):null;
    }catch(e){return null;}
  }

  function descriptionContent(product){
    const html=product?.description||'';
    const box=document.createElement('div');
    box.innerHTML=String(html);

    // Use whole paragraphs, not headings joined directly to paragraphs.
    const paragraphs=[...box.querySelectorAll('p')]
      .map(p=>clean(p.textContent||p.innerText||''))
      .filter(Boolean);
    const firstParagraph=paragraphs[0]||clean(box.textContent||box.innerText||'');

    // Split only at punctuation followed by whitespace, preserving "2.0".
    const sentences=text=>clean(text).split(/(?<=[.!?])\s+/)
      .map(clean).filter(Boolean);
    const openingSentences=sentences(firstParagraph);
    let summary=openingSentences[0]||firstParagraph;
    if(summary.length>185) summary=summary.slice(0,182).replace(/\s+\S*$/,'')+'…';

    let highlights=[...box.querySelectorAll('li')]
      .map(li=>clean(li.textContent))
      .filter(t=>t.length>=12&&t.length<=130);

    // For prose descriptions, use intact sentences from the introduction.
    // Do not convert product titles or broken sentence fragments to benefits.
    if(highlights.length<2){
      const sentenceHighlights=paragraphs.slice(0,2)
        .flatMap(sentences).slice(1)
        .map(s=>s.replace(/[.!?]+$/,''))
        .filter(s=>s.length>=18&&s.length<=150);
      highlights=[...highlights,...sentenceHighlights];
    }

    const seen=new Set();
    highlights=highlights.filter(item=>{
      const key=item.toLowerCase();
      if(seen.has(key)||key===summary.toLowerCase())return false;
      seen.add(key);return true;
    }).slice(0,3);

    return {summary,highlights};
  }

  function moveReview(meta){
    if(!meta)return false;
    const title=meta.querySelector('.product-single__title');
    if(!title)return false;
    const badge=meta.querySelector('.jdgm-prev-badge, .jdgm-preview-badge, .jdgm-widget.jdgm-preview-badge');
    if(!badge)return false;
    const titleBlock=title.closest('.product-block')||title.parentElement;
    let reviewBlock=badge.closest('.shopify-block')||badge.closest('.shopify-app-block')||badge.parentElement;
    reviewBlock=directChild(reviewBlock,meta);
    if(!reviewBlock||reviewBlock===titleBlock)return false;
    if(titleBlock.nextElementSibling!==reviewBlock) titleBlock.insertAdjacentElement('afterend',reviewBlock);
    reviewBlock.classList.add('ruffo-pdp-review-proof');
    return true;
  }

  function addSummary(section,meta,product){
    if(!meta||!product||meta.querySelector('.ruffo-pdp-cro-summary'))return;
    const content=descriptionContent(product);
    if(!content.summary)return;
    const wrap=document.createElement('div');
    wrap.className='ruffo-pdp-cro-summary';
    const p=document.createElement('p');
    p.className='ruffo-pdp-benefit-line';
    p.textContent=content.summary;
    wrap.appendChild(p);
    if(content.highlights.length){
      const ul=document.createElement('ul');
      ul.className='ruffo-pdp-highlights';
      content.highlights.forEach(text=>{const li=document.createElement('li');li.textContent=text;ul.appendChild(li);});
      wrap.appendChild(ul);
    }
    const priceCandidate=meta.querySelector('.product-price, .product-single__price, [id^="ProductPrice-"]');
    const priceBlock=priceCandidate?(priceCandidate.closest('.product-block')||directChild(priceCandidate,meta)):null;
    const title=meta.querySelector('.product-single__title');
    const titleBlock=title?(title.closest('.product-block')||directChild(title,meta)):null;
    if(priceBlock&&priceBlock.parentElement===meta) priceBlock.insertAdjacentElement('afterend',wrap);
    else if(titleBlock&&titleBlock.parentElement===meta) titleBlock.insertAdjacentElement('afterend',wrap);
  }

  function addFitHelp(section,product){
    if(!product?.options?.length)return;
    const sizeIndex=product.options.findIndex(o=>/size/i.test(typeof o==='string'?o:(o?.name||'')));
    if(sizeIndex<0)return;
    const input=section.querySelector('[data-index="option'+(sizeIndex+1)+'"]');
    if(!input)return;
    const wrapper=input.closest('.selector-wrapper')||input.closest('.product-form__item')||input.parentElement;
    if(!wrapper||wrapper.querySelector('.ruffo-fit-confidence'))return;
    wrapper.classList.add('ruffo-size-selector-cro');

    const tools=wrapper.querySelector('.ruffo-sizing-tools');
    const card=document.createElement('div');
    card.className='ruffo-fit-confidence';
    const copy=document.createElement('div');
    copy.className='ruffo-fit-confidence__copy';
    copy.innerHTML='<span class="ruffo-fit-confidence__title">Find the right fit</span><span class="ruffo-fit-confidence__text">Measure your dog and use our sizing tools before ordering for the closest match.</span>';
    card.appendChild(copy);

    if(tools){
      tools.classList.add('ruffo-sizing-tools--cro-moved');
      card.appendChild(tools);
    }

    const control=input.closest('fieldset')||input.closest('select')||input;
    control.insertAdjacentElement('afterend',card);
  }

  function addReassurance(section){
    if(section.querySelector('.ruffo-pdp-purchase-reassurance'))return;
    const id=section.dataset.sectionId;
    const button=document.getElementById('AddToCart-'+id)||section.querySelector('[name="add"]');
    if(!button)return;
    const row=document.createElement('div');
    row.className='ruffo-pdp-purchase-reassurance';
    ['Secure checkout','Tracked UK delivery','Size help available'].forEach(text=>{
      const span=document.createElement('span');span.textContent=text;row.appendChild(span);
    });
    const holder=button.closest('.product-form__item, .product-form__cart-submit, .product-form__buttons')||button.parentElement;
    holder.insertAdjacentElement('afterend',row);
  }

  function init(section){
    if(!section||section.dataset.ruffoPdpCroReady)return;
    const product=productData(section);
    const meta=section.querySelector('.product-single__meta');
    if(!product||!meta)return;
    section.dataset.ruffoPdpCroReady='true';
    addSummary(section,meta,product);
    addFitHelp(section,product);
    addReassurance(section);

    const tryReview=()=>moveReview(meta);
    tryReview();
    [250,700,1400,2500].forEach(ms=>setTimeout(tryReview,ms));
    const observer=new MutationObserver(()=>{if(tryReview()) observer.disconnect();});
    observer.observe(meta,{childList:true,subtree:true});
    setTimeout(()=>observer.disconnect(),5000);
  }

  const all=()=>document.querySelectorAll('[data-section-type="product"]').forEach(init);
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',all);else all();
  document.addEventListener('shopify:section:load',e=>{
    const section=e.target.querySelector?.('[data-section-type="product"]')||(e.target.matches?.('[data-section-type="product"]')?e.target:null);
    if(section){delete section.dataset.ruffoPdpCroReady;init(section);}
  });
})();
